export default __webpack_public_path__ + "static/media/add-icon.a29ee53d.svg";